import { SOCKET_EVENTS } from '@constants';
import { destroyCookie } from '@utils';
import { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useSocket } from '@/hooks';
import { useProfile } from '@/store';

const TIMEOUT = 500;

export const EjectionHandler = () => {
  const { on, off } = useSocket();
  const { profile } = useProfile();
  const navigateTo = useNavigate();

  const handleEjectUser = useCallback(
    (userId: string) => {
      if (userId !== profile?._id) return;
      destroyCookie('token', import.meta.env.VITE_COOKIE_DOMAIN);

      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'EJECT_USER' }));
      }

      setTimeout(() => {
        navigateTo('/login');
        window.location.reload();
      }, TIMEOUT);
    },
    [profile?._id, navigateTo]
  );

  useEffect(() => {
    on(SOCKET_EVENTS.EJECT_USER, handleEjectUser);
    return () => {
      off(SOCKET_EVENTS.EJECT_USER, handleEjectUser);
    };
  }, [handleEjectUser, off, on]);

  return null;
};
